import { UserDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum UserEventTypes {
  USER_UPDATED = '[User] User Updated',
  USER_DELETED = '[User] User Deleted',
}

/**
 * Payloads
 */
export interface UserUpdatedEventPayload {
  user: UserDto;
}

/**
 * Events
 */
export class UserUpdatedEvent {
  readonly type = UserEventTypes.USER_UPDATED;

  constructor(public payload: UserUpdatedEventPayload) {}
}

export class UserDeletedEvent {
  readonly type = UserEventTypes.USER_UPDATED;

  constructor(public payload: UserUpdatedEventPayload) {}
}
